import { createFileRoute } from '@tanstack/react-router';
import ListsPage from '../../views/dashboard-lists';

export const Route = createFileRoute('/dashboard/lists/')({
  component: ListsPage,
});
